// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./style/style.css
// module id = 639
// module chunks = 0